var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fa-duotone-group"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill-secondary",
    fill: "#304A5C",
    opacity: 0.4,
    d: "M144 256c0-17.67-14.33-32-32-32s-32 14.33-32 32v32H0v160c0 35.35 28.65 64 64 64h160v-80H192c-17.67 0-32-14.33-32-32s14.33-32 32-32h32V288H144V256zM448 0h-96c-17.67 0-32 14.33-32 32v32h32c17.67 0 32 14.33 32 32s-14.33 32-32 32h-32v64h64v16c0 17.67 14.33 32 32 32s32-14.33 32-32V192h32c17.67 0 32-14.33 32-32V64C512 28.65 483.3 0 448 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-primary",
    fill: "#304A5C",
    d: "M256 208c17.67 0 32-14.33 32-32s-14.33-32-32-32H224V96c0-17.67-14.33-32-32-32H64C28.65 64 0 92.65 0 128v160h80V256c0-17.67 14.33-32 32-32s32 14.33 32 32v32H224V208H256zM416 288h-48v32c0 17.67-14.33 32-32 32s-32-14.33-32-32V288H224v80H192c-17.67 0-32 14.33-32 32s14.33 32 32 32h32V512h160c35.35 0 64-28.65 64-64v-128C448 302.3 433.7 288 416 288z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPuzzle);
export default __webpack_public_path__ + "static/media/ico-puzzle.5c96e4bea2452b1ce9f4455dc8094d39.svg";
export { ForwardRef as ReactComponent };